import React from 'react';
import classnames from 'classnames';

import "./scrapbook-title.scss";
import { ScrapbookStore } from '../../store/ScrapbookStore';
import { IScrapbook} from '../../models/IScrapbook';

export interface IProps {
    store: ScrapbookStore;
    scrapbook: IScrapbook;
}
export interface IState {
    isEditing: boolean;
    isSyncing: boolean;
    title: string;
}

export class ScrapbookTitle extends React.Component <IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.onTitleChange = this.onTitleChange.bind(this);
        this.onTitleClick = this.onTitleClick.bind(this);
        this.onInputKeyDown = this.onInputKeyDown.bind(this);
        this.onSaveNewTitle = this.onSaveNewTitle.bind(this);

        this.state = {
            isEditing: false,
            isSyncing: false,
            title: ""
        };
    }

    public render(){
        return <div className={classnames("scrapbook-title-root")}>
                    { this.renderContent()}
               </div>
    }

    private renderContent(){
        const scrapbook = this.props.scrapbook;
        if(scrapbook == null) { return null; }

        if(scrapbook.product != null) {
            return <h5>{scrapbook.product.title}</h5>;
        }
        
        if(scrapbook.notebook != null){
            return this.renderScrapNotebookTitle(scrapbook)
        }

        return null;
    }

    private renderScrapNotebookTitle(scrapbook: IScrapbook){
        if(this.state.isEditing){
            return <input type="text" placeholder="enter title" 
                               onChange={this.onTitleChange} 
                               value={this.state.title} ref={this.handleInputRef}
                               onBlur={this.onSaveNewTitle}
                               onKeyDown={this.onInputKeyDown}
                               disabled={this.state.isSyncing}/>
                        
        }
        else {
            return <h5 className="scrapbook-notebook-title" onClick={this.onTitleClick}>
                    { scrapbook.notebook.title 
                    ? scrapbook.notebook.title
                    : <>new notebook <span className="_demphasized">(replace with your title)</span></>}
                   </h5>
        }
    }

    private onTitleClick(){
        this.setState({
            isEditing: true,
            title: this.props.scrapbook.notebook.title
        });
    }

    private onTitleChange(e){
        const newTitle = e.target.value;
        
        this.setState({
            title: newTitle
        });
    }

    private handleInputRef(inputElement: HTMLInputElement){
        inputElement && inputElement.focus();
    }

    private onInputKeyDown(e){
        const keyCode = e.keyCode || e.which;
        if(keyCode == 13) { //Enter
            this.onSaveNewTitle()
        }
        else if(keyCode == 27){ //Esc
            this.setState({
                isEditing: false
            });
        }
    }

    private onSaveNewTitle(){
        if(this.state.title != this.props.scrapbook.notebook.title
        && this.state.title){
            this.setState({
                isSyncing: true
            });
            
            this.props.store.updateScrapbookTitle(this.props.scrapbook, this.state.title).then(() => {
                this.setState({
                    isEditing: false,
                    isSyncing: false
                });
            }).catch(() => {
                alert("Error when updating title. Please try later.")
                this.setState({
                    isSyncing: false
                });
            });
        }
        else {
            this.setState({
                isEditing: false
            });
        }
    }
}